/**
 * Created by yujn on 2017/11/7.
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

import ActivityPage2 from './ActivityPage2'
import ActivityPage3 from './ActivityPage3'
import CarList from './CarList'
import CarInfo from './CarInfo'
Vue.use(VueRouter);
// // 创建一个路由器实例
// // 并且配置路由规则
const router = new VueRouter({
     routes: [
         {
             path:"/",
             redirect:"/ActivityPage2"
         },

         {
             path: '/ActivityPage2',
             component: ActivityPage2
         },
         {
             path: '/ActivityPage3',
             component: ActivityPage3
         },
         {
             path:'/CarList',
             component:CarList
         },
         {
             path:'/CarInfo',
             component:CarInfo
         }
     ]
 })
//
// // 现在我们可以启动应用了！
// // 路由器会创建一个 App 实例，并且挂载到选择符 #index 匹配的元素上。
// /* eslint-disable no-new */
 new Vue({
     router: router
 }).$mount('#pageActivity')



// WEBPACK FOOTER //
// ./src/module/PicActivity/Pictivity.js